import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { clsx } from "clsx";
import type { HTMLInputTypeAttribute, InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  type?: HTMLInputTypeAttribute;
  width: string;
};

export function Input({
  label,
  id,
  type,
  width,
  className,
  ...props
}: InputProps) {
  return (
    <div className={clsx(width, "flex flex-col text-gray-200")}>
      <text
        className={"block pl-4 font-medium text-gray-400 text-sm leading-6"}
      >
        {label}
      </text>

      <div
        id={id}
        className={twMerge(
          "relative flex h-full w-full cursor-default items-center border border-gray-600 bg-gray-900 py-1.5 pr-2 pl-3 text-left text-gray-400 shadow-sm sm:text-sm sm:leading-6",
          className,
        )}
      >
        {type === "search" && (
          <MagnifyingGlassIcon
            className={"mr-2 h-5 w-5 text-gray-400"}
            aria-hidden="true"
          />
        )}
        <input
          className={"w-full bg-slate-900 p-1 focus:outline-none"}
          type={type}
          {...props}
        />
      </div>
    </div>
  );
}
